const AbnormalityTypes = [
    "CN_LOH",
    "Loss",
    "Gain",
    "Deletion",
    "Homo_Loss"
];
export default AbnormalityTypes;